import React from 'react'

import {Authenticate} from './Authenticate.jsx'

import {SessionStorage} from 'storage/Session'

/* eslint-disable no-unused-vars */
const RequireAuthInner = ({session, resolved, children, ...rest}) =>
   /* eslint-enable */
   (resolved
      ? React.cloneElement(children, {...rest})
      : <Authenticate redirect={false} {...rest} />)

RequireAuthInner.defaultProps = {
   resolved: false,
   session:  {}
}

RequireAuthInner.propTypes = {
   children: React.PropTypes.any.isRequired,
   resolved: React.PropTypes.bool.isRequired,
   session:  React.PropTypes.object
}

export const RequireAuth = props => (
   <SessionStorage valid={false}>
      <RequireAuthInner {...props} />
   </SessionStorage>
)



// WEBPACK FOOTER //
// lib/bundle/auth/RequireAuth.jsx